import { useSearchParams } from "react-router-dom";
import { usePassions } from "../hooks/usePassions2";
import { useBeverages } from "../hooks/useBeverages";
import stylesBanner from "../pages/CarouselExplorePage/TopBanner/TopBanner.module.css";
import { passionsParams } from "./passionsData.js";

const beverageCategories = ["AM Drinks", "Afternoon Drinks", "Evening Drinks"];

const getBannerSize = (tapsCount) => {
  return tapsCount > 1 ? stylesBanner.love : stylesBanner.like;
};

export const useExplorePassions = (experienceType) => {
  const [searchParams] = useSearchParams();
  const { isPassionSelected, getPassionValue } = usePassions(experienceType);
  const { isAnyBeverageSelected, getSelectedBeveragesAsArray } = useBeverages();

  const passion = searchParams.get("passion");

  // Handle beverage experience type
  if (experienceType === "beverage") {
    if (!isAnyBeverageSelected()) {
      return [];
    }

    const selectedBeverages = getSelectedBeveragesAsArray();
    const hasLoved = selectedBeverages.some(b => b.preference === "love");

    return beverageCategories.map((category) => ({
      passion: category.toLowerCase().replace(" ", "-"),
      taps: hasLoved ? 2 : 1,
      style: getBannerSize(hasLoved ? 2 : 1),
    }));
  }

  if (passion && passionsParams.includes(passion)) {
    const taps = getPassionValue(passion);

    return [
      {
        passion,
        taps,
        style: getBannerSize(taps),
      },
    ];
  }

  const passions = passionsParams
    .map((passion) => {
      if (!isPassionSelected(passion)) {
        return null;
      }

      const taps = getPassionValue(passion);

      return { passion, taps, style: getBannerSize(taps) };
    })
    .filter(Boolean)
    .sort((a, b) => b.taps - a.taps);

  return passions;
};
